import { Component, OnInit, ViewChild } from '@angular/core';
import { IonPullUpFooterState } from 'ionic-pullup';
import { HistoricalService } from '../historical.service';
import { Subscription } from 'rxjs';
import { Mileage } from 'src/app/model/historical';
import { Group, Vehicule } from 'src/app/model/data-managemnt';
import * as L from 'leaflet';
import Marker = L.Marker;
import Icon = L.Icon;
import { DatePipe } from "@angular/common";
import { MileageModalComponent } from './mileage-modal/mileage-modal.component';
import { ModalController, Platform, PopoverController } from '@ionic/angular';
import { DataManagementService } from '../../data-management/data-management.service';
import { MapService } from 'src/app/utils/leaflet/service/map.service';
import { SigninService } from 'src/app/signin/signin.service';
import { Map } from "leaflet";
import { GlobalService } from 'src/app/global.config';
import { LoadingService } from 'src/app/utils/loading/loadingService';
import { RealtimeWorkerService } from 'src/app/pages/realtime/realtime-worker.service';
import { TrackControleComponent } from "../../../utils/leaflet/track-controle/track-controle.component";

@Component({
  selector: 'app-mileage',
  templateUrl: './mileage.component.html',
  styleUrls: ['./mileage.component.scss'],
})
export class MileageComponent implements OnInit {

  @ViewChild(MileageModalComponent, { static: false }) mileageModalComponent: MileageModalComponent;

  footerState: IonPullUpFooterState;
  AllMileages: Subscription;
  totalMileage: Mileage;
  mileageClicked: Mileage;

  groups: Group[];
  //selectedGroup: Group = new Group();
  isResultLoaded: boolean = true;
  mileages: Mileage[] = [];
  mileagesExport: Mileage[] = [];
  selectedVehicule: Vehicule = new Vehicule();
  MileageArray = [];
  mileageMap: Map;
  backButtonSubscription: Subscription;
  loading: boolean;
  constructor(public historicalService: HistoricalService, private mapService: MapService,
    private popoverController: PopoverController, public dataManagementService: DataManagementService,
    public signinService: SigninService,
    private globalService: GlobalService, public dataPipe: DatePipe,
    public loadingService: LoadingService,
    private modalController: ModalController,
    private realTimeWorker: RealtimeWorkerService) {

    this.footerState = IonPullUpFooterState.Collapsed;
    this.historicalService.selectedTab = "mileage";
  }

  ngOnInit() {

  }

  ionViewWillEnter() {
    const vehicle = this.dataManagementService.ensureSelectedVehicle();
    const deviceId = this.dataManagementService.getSelectedDeviceId();
    if (vehicle) {
      this.selectedVehicule = vehicle;
    }
    if (!deviceId) {
      this.historicalService.mileages = [];
      return;
    }
    if (this.historicalService.mileagesLoadedForDeviceId === deviceId) {
      return;
    }

    this.loadMileages(deviceId);
  }

  private loadMileages(deviceId: number) {
    this.historicalService.mileagesLoadedForDeviceId = deviceId;
    this.loading = true;
    let endDate = this.historicalService.endDate;
    let startDate = this.historicalService.startDate;
    this.historicalService.getAllMileages(deviceId, { startDate, endDate }).subscribe(
      mileages => {
        this.loading = false
        this.historicalService.mileages = this.historicalService.sortByDateDesc(mileages, m => m.startHour)
        console.log(mileages);
      }
    );
  }

  ionViewDidEnter() {
    if (this.mapService.preventMapDestroy) {
      this.mapService.preventMapDestroy = false;
      setTimeout(() => {
        if (this.mapService.map) {
          this.mapService.map.invalidateSize();
          this.realTimeWorker.syncSelectedVehicleMarkerOnMap();
        }
      }, 150);
      return;
    }
    this.mapService.initMap(this.mileageMap, "mileageMap");
    setTimeout(() => this.realTimeWorker.syncSelectedVehicleMarkerOnMap(), 200);
    this.expandFooterPanel();
  }

  ionViewWillLeave() {
    if (!this.mapService.preventMapDestroy && this.mapService.map) {
      this.mapService.map.remove();
    }
  }

  footerExpanded() {
    console.log('Footer expanded!');
  }

  footerCollapsed() {
    console.log('Footer collapsed!');
  }

  toggleFooter() {

    this.footerState = this.footerState === IonPullUpFooterState.Collapsed ? IonPullUpFooterState.Expanded : IonPullUpFooterState.Collapsed;
  }

  private expandFooterPanel(): void {
    setTimeout(() => {
      this.footerState = IonPullUpFooterState.Expanded;
    }, 600);
  }

  ngOnDestroy() {
    if (this.AllMileages) this.AllMileages.unsubscribe();
  }


  private searchPopoverOpen = false;

  async openPopover() {
    if (this.searchPopoverOpen) {
      return;
    }
    this.searchPopoverOpen = true;
    const popover = await this.popoverController.create({
      id: 'historique-search-popover',
      component: MileageModalComponent,
      cssClass: 'historiquePopovers',
      alignment: 'center',
      backdropDismiss: true,
    });
    popover.onDidDismiss().then(() => {
      setTimeout(() => {
        this.searchPopoverOpen = false;
      }, 450);
    });
    await popover.present();
  }

  MiileageSelected(mileage: any) {
    return this.MileageArray.indexOf(mileage as never) !== -1;
  }

  addMileageToArray(mileage: any, event: any) {
    if (!event.ctrlKey) {
      this.MileageArray = [];
      this.mapService.removePolylinesFromMap();
      this.mapService.removeMarkersFromMap();
    }

    this.MileageArray.push(mileage as never);
    this.drawMileage(mileage);
    this.footerState = IonPullUpFooterState.Collapsed;
  }

  /**
   * Open track control modal instead of navigating to a new page
   */
  async openTrackControlModal(playBackPath: any, trackType: string) {
    const modal = await this.modalController.create({
      component: TrackControleComponent,
      componentProps: {
        trackData: playBackPath,
        trackType: trackType
      },
      cssClass: 'track-control-modal',
      backdropDismiss: true,
      showBackdrop: true
    });

    modal.onDidDismiss().then(() => {
      modal.dismiss();
    })

    await modal.present();

    // Handle modal dismissal if needed
    const { data } = await modal.onWillDismiss();
    if (data) {
      console.log('Modal dismissed with data:', data);
      // Handle any data returned from the modal
    }
  }

  MileageSelected(mileage: any) {
    return this.MileageArray.indexOf(mileage as never) !== -1;
  }
  drawMileage(mileage: any) {
    if (
      this.mileageClicked == null ||
      this.mileageClicked.startHour != mileage.startHour
    ) {
      this.mileageClicked = new Mileage();
      this.mileageClicked.startHour = mileage.startHour;
      this.mileageClicked.endHour = mileage.endHour;
    }
    /*this.mapService.removePolylinesFromMap();
     this.mapService.removeMarkersFromMap();*/
    let maxSpeed = this.dataManagementService.selectedVehicule?.maxSpeed || 90;
    let startHour: any = mileage.startHour;
    const deviceId = this.dataManagementService.getSelectedDeviceId();
    if (!deviceId) {
      return;
    }
    this.historicalService
      .getMileageDetails(deviceId, {
        startDate: startHour,
        endDate: mileage.endHour
      })
      .subscribe(mileage => {
        this.openTrackControlModal(mileage, "mileage");
      });
  }

  get totalDrivingDistance(): number {
    return this.historicalService.mileages
      ?.reduce((sum, m) => sum + (m.drivingDistance || 0), 0) || 0;
  }

  get totalDrivingDuration(): number {
    // Sum up all drivingDuration values (in seconds)
    return this.historicalService.mileages
      ?.reduce((sum, m) => sum + (m.drivingDurationStr || 0), 0) || 0;
  }

  get totalDrivingDurationStr(): string {
    const totalSeconds = this.totalDrivingDuration;

    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = Math.floor(totalSeconds % 60);

    // Format as HH:MM:SS
    return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  }

  get totalDrivingDistanceFormatted(): string {
    return `${this.totalDrivingDistance.toFixed(2)} km`;
  }

  get averageSpeed(): number {
    const totalDurationHours = this.totalDrivingDuration / 3600;
    return totalDurationHours > 0 ? this.totalDrivingDistance / totalDurationHours : 0;
  }

  get averageDistancePerTrip(): number {
    const tripCount = this.historicalService.mileages?.length || 0;
    return tripCount > 0 ? this.totalDrivingDistance / tripCount : 0;
  }

  calculateTotalDistance(mileages: any) {
    let totalDistance = 0;
    mileages.forEach(mileage => {
      totalDistance += mileage.drivingDistance;
    });
    return totalDistance;
  }

  calculateTotalDrivingDurationStr(mileages: any[]): string {
    let totalSeconds = 0;

    // Convert duration string to seconds
    const durationStrToSeconds = (durationStr: string) => {
      let hours = 0, minutes = 0, seconds = 0;

      // Regex to find hours, minutes, and seconds in the string
      const hourMatch = durationStr.match(/(\d+)\s*h/);
      const minuteMatch = durationStr.match(/(\d+)\s*min/);
      const secondMatch = durationStr.match(/(\d+)\s*sec/);

      if (hourMatch) {
        hours = parseInt(hourMatch[1], 10);
      }
      if (minuteMatch) {
        minutes = parseInt(minuteMatch[1], 10);
      }
      if (secondMatch) {
        seconds = parseInt(secondMatch[1], 10);
      }

      // Convert everything to seconds and return
      return (hours * 3600) + (minutes * 60) + seconds;
    };

    // Loop through the mileage array and sum the durations
    mileages.forEach(mileage => {
      if (mileage.drivingDurationStr) {
        totalSeconds += durationStrToSeconds(mileage.drivingDurationStr);
      }
    });

    // Convert total seconds back to hh:mm:ss format
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    return `${hours} h ${minutes} min ${seconds} sec`;
  }
}
